<template>
  <!--<transition name="custom" enter-active-class="animated slideInRight" leave-active-class="animated slideOutLeft">-->
    <div class="thanks Thanks.vue full-container">
      <!--<main-menu class="no-logo"></main-menu>-->
      <div class="thanks__content">
        <h1 class="title-primary hero animated fadeInUp delay1000ms"><i class="arrow simple left big animated"></i>{{ guestName }}<i class="arrow simple big"></i></h1>
        <h2 class="title-primary animated fadeInUp delay1000ms">Massa! Você está mais próximo de se tornar <span class="sub">Bold!</span></h2>

        <p class="text-second animated fadeInUp delay1000ms">Enquanto aguarda nossa resposta,<br>curte as nossas páginas nas redes sociais:</p>
        <div class="social animated fadeInUp delay1000ms">
          <a class="box-social" href="https://www.facebook.com/boldcomunicacao/" target="_blank">
            <icoFace></icoFace>
            <span>Curta</span>
          </a>
          <a class="box-social" href="https://www.instagram.com/boldcomunicacao" target="_blank">
            <icoInsta></icoInsta>
            <span>Siga</span>
          </a>
          <a class="box-social" href="https://www.youtube.com/channel/UCyp4B226-dw25ROkQujTXtw" target="_blank">
            <icoYoutube></icoYoutube>
            <span>Inscreva-se</span>
          </a>
        </div>
        <logo class="thanks__logo animated fadeInUp delay1000ms"></logo>

        <!-- /.social -->
      </div>
      <!-- /.thanks__content -->
    </div>
  <!--</transition>-->
</template>

<script>
  import MainMenu from './MainMenu.vue'
  import logo from '../assets/logo.svg';
  import icoFace from '../../static/media/ico-facebook.svg';
  import icoInsta from '../../static/media/ico-instagram.svg';
  import icoYoutube from '../../static/media/ico-youtube.svg';

  export default {
    name: 'Thanks',
    data() {
      return {}
    },
    components:{
      MainMenu,
      logo,
      icoFace,
      icoInsta,
      icoYoutube

    },
    computed: {
      guestName() {
        return this.$store.getters.guestFirstName;
      }
    },
    mounted(){
      // seta a classe do menu principal
      this.$store.commit('setMenuClass', 'no-logo');
      setTimeout(()=>{
        $('.loading').addClass('hideL');
      }, 1000);
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/Thanks.vue